<div class="skills-filter">
  <input
    class="skills-filter__input"
    [class.skills-filter__input--open]="isSuggestionsVisible"
    type="text"
    [formControl]="skillInput"
    [placeholder]="placeholder | translate"
    (focus)="openSuggestions()"
    (input)="openSuggestions()"
    (keydown.escape)="closeSuggestions()"
  />

  @if (isSuggestionsVisible && suggestions; as visibleSuggestions) {
    <div class="suggestions">
      @for (item of visibleSuggestions.queryResultItems; track item.skillId) {
        <div class="suggestions__item" (click)="selectSkill(item)">
          @if (getMatchSplit(item.name); as parts) {
            <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
          }
        </div>
      }
      @for (item of visibleSuggestions.suggestedItems; track item.skillId) {
        <div class="suggestions__item" (click)="selectSkill(item)">
          @if (getMatchSplit(item.name); as parts) {
            <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
          }
        </div>
      }
    </div>
  }

  @if (skills && skills.length > 0) {
    <div
      class="skills-filter__chosen"
      #chosenSkills
      [style.max-height]="clampMaxHeight"
    >
      <hrra-skills
        [skills]="skills"
        [userType]="userType.Anonymous"
        [editable]="false"
        [removable]="true"
        [compact]="true"
        (onRemoveSkill)="removeSkill($event)"
      ></hrra-skills>
    </div>

    @if (isClamped()) {
      <span class="skills-filter__all" (click)="showAllSkills()">
        {{ 'label.All' | translate }}
      </span>
    }
  }
</div>
